//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import moment from 'moment';
import { Form } from 'react-bootstrap'
import NumberFormat from 'react-number-format';
//@end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
import {ITrainingFields} from 'app_types/admin/landings/landingTypes'
// @end

// @INFO Import services
import CourseService from 'app_services/admin/course/courseService'
// @end


// @INFO Import Styles
import './../modalTrainingFormModule.scss'

const uuid = require('react-uuid')

// @ADD Component types
interface IModalTrainingFormModuleLayoutProps {
  open          : boolean
  processing    : boolean
  customErrors? : any
  editData?     : any
  handleClose   : (data:any)=>void
  onHandleSubmit: (data: any) => void
  fields?: Array<ITrainingFields>
}

const ModalTrainingFormModuleLayout: React.FC<IModalTrainingFormModuleLayoutProps> = (props) => {

  const [colors] = useColors()
  const courseService: CourseService = new CourseService();
  const [price, setPrice] = useState<{formated: string, value: string}>({formated: '', value: '0'})


  const {open} = props

  const [trainingStatus, setTrainingStatus] = useState<boolean>(false)
  const [listOfCourseCards, setListOfCourseCards] = useState<Array<any>>([])

  const formHook = useForm()
  const { t } = useTranslation()

  const handleCloseModal = (data: any) => {
    props.handleClose(data)
  }

  const handleChangeStatus = (e: any) => {
    setTrainingStatus(!trainingStatus)
  }

  useEffect(() => {
    getCourseCards()
  }, [])

  useEffect(() => {
    if (props?.editData) {
      setTrainingStatus((props?.editData?.status) ? props?.editData?.status : false)
      if (props?.editData?.price) {
        setPrice({formated: props?.editData?.price, value: props?.editData?.price})
      }
    }
  }, [props,props.editData])

  const getCourseCards = async () => {
    const courses: Array<any> = []
    const courseResponse = await courseService.list()
    if (courseResponse) {
      courseResponse.courses.map((course: any) => {
        courses.push({ value: course._id, label: course?.program?.name })
      })
    }
    setListOfCourseCards(courses)
  }

  return(
    <div className=''>
      <Modal show={open} onHide={() => handleCloseModal({ status: false })} className="modal_training_form-module">
        <Modal.Header>
          <Modal.Title>
            {t('modules.modal_training_form.title')}
          </Modal.Title>
          <div className="close-button" onClick={() => handleCloseModal({status: false})}>
            <IconComponent
              color={colors.secondary}
              width='1.5rem'
              height='1.5rem'
              fontawesome={{
                icon: 'fas fa-times-circle',
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>
            <input
              type="hidden"
              name="unique"
              defaultValue={(props?.editData?.unique) ? props?.editData?.unique : uuid()}
              ref={formHook.register({ required: true })}
            />
            <div className="col-md-12">
              <div className="form-group">
                <Form.Check
                  type='switch'
                  id='status'
                  name='status'
                  label={t('labels.modal_training_form.status')}
                  onChange={(event: any) => handleChangeStatus(event)}
                  checked={trainingStatus}
                  ref={formHook.register()}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='publication_date'>{t('labels.modal_training_form.publication_date')}</label>
                <input
                  type='date'
                  className='form-control'
                  name='publication_date'
                  defaultValue={moment.utc(props?.editData?.publication_date).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                  ref={formHook.register({ required: true })}
                />
              </div>
            </div>
            {props.fields && props.fields.includes('course') && (
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor='course'>{t('labels.modal_training_form.course')}</label>
                  {formHook.errors?.course && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <ReactSelectComponent
                    identifier='course'
                    options={listOfCourseCards}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.course) ? [{value: props?.editData?.course._id, label: props?.editData?.course?.program?.name}] : []}
                    isMulti={false}
                    required={true}
                  />
                </div>
              </div>
            )}
            {props.fields && props.fields.includes('attached') && (
              <>
                <div className="col-12">
                  <div className='form-group'>
                    <label htmlFor='attached'>{t('labels.modal_training_form.attached')}</label>
                    {formHook.errors?.attached && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='attached'
                      name='attached'
                      className='form-control-file'
                      type='file'
                      ref={formHook.register({ required: false })}
                    />
                    {formHook.errors?.attached && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
                {props?.editData?.attachedFile && (
                  <>
                    <input type="hidden" name="attachedUrl" value={props?.editData?.attachedUrl} ref={formHook.register({ required: true })} />
                    <div className="col-md-12">
                      <div className="form-group">
                          <div className="cover-container">
                            <img src={props?.editData?.attachedFile} alt=""/>
                          </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            {props.fields && props.fields.includes('title') && (
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor='title'>{t('labels.modal_training_form.title')}</label>
                  {formHook.errors.title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='title'
                    name='title'
                    className={`form-control ${formHook.errors.title && 'is-invalid'}`}
                    type='text'
                    ref={formHook.register({ required: true })}
                    defaultValue={props?.editData?.title}
                  />
                </div>
              </div>
            )}
            {props.fields && props.fields.includes('description') && (
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor='description'>{t('labels.modal_training_form.description')}</label>
                  {formHook.errors.description && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <textarea
                    id='description'
                    name='description'
                    className={`form-control ${formHook.errors.description && 'is-invalid'}`}
                    ref={formHook.register({ required: true })}
                    defaultValue={props?.editData?.description}
                  ></textarea>
                </div>
              </div>
            )}
            {props.fields && props.fields.includes('modality') && (
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor='modality'>{t('labels.modal_training_form.modality')}</label>
                  {formHook.errors.modality && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='modality'
                    name='modality'
                    className={`form-control ${formHook.errors.modality && 'is-invalid'}`}
                    type='text'
                    ref={formHook.register({ required: false })}
                    defaultValue={props?.editData?.modality}
                  />
                </div>
              </div>
            )}
            {props.fields && props.fields.includes('city') && (
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor='city'>{t('labels.modal_training_form.city')}</label>
                  {formHook.errors.city && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='city'
                    name='city'
                    className={`form-control ${formHook.errors.city && 'is-invalid'}`}
                    type='text'
                    ref={formHook.register({ required: false })}
                    defaultValue={props?.editData?.city}
                  />
                </div>
              </div>
            )}
            {props.fields && props.fields.includes('start_date') && (
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='start_date'>{t('labels.modal_training_form.start_date')}</label>
                  <input
                    type='date'
                    className='form-control'
                    name='start_date'
                    defaultValue={moment.utc(props?.editData?.start_date).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                    ref={formHook.register({ required: false })}
                  />
                </div>
              </div>
            )}

            {props.fields && props.fields.includes('price') && (
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='price'>{t('labels.modal_training_form.price')}</label>
                  <NumberFormat
                    thousandSeparator={true}
                    prefix={'$'}
                    value={price.formated}
                    className={`form-control ${formHook.errors.price && 'is-invalid'}`}
                    onValueChange={(values) => {
                      const { formattedValue, value } = values;
                      setPrice({formated: formattedValue, value});
                    }}
                  />
                  <input type="hidden" name="price" value={price.value} ref={formHook.register({ required: true })} />
                </div>
              </div>
            )}

            {props.fields && props.fields.includes('video') && (
              <>
                <div className="col-md-12">
                  <div className='form-group '>
                    <label htmlFor='platform_video'>{t('labels.modal_training_form.platform_video')}</label>
                    {formHook.errors?.platform_video && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <ReactSelectComponent
                      identifier='platform_video'
                      options={[{ label: 'youtube', value: 'youtube' }, { label: 'vimeo', value: 'vimeo' }]}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.platform_video) ? [{ value: props?.editData?.platform_video, label: props?.editData?.platform_video }] : []}
                      isMulti={false}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className='form-group '>
                    <label htmlFor='url_video'>{t('labels.modal_training_form.url_video')}</label>
                    {formHook.errors?.url_video && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='url_video'
                      name='url_video'
                      className={`form-control ${formHook.errors?.url_video && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: true })}
                      defaultValue={props?.editData?.url_video}
                    />
                  </div>
                </div>
              </>
            )}

            <div className='buttons-group'>
              <div className='text-center'>
                <button className='btn btn-secondary' type='submit' disabled={props.processing}>
                  {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                  {t('modules.modal_training_form.form.save')}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ModalTrainingFormModuleLayout
